/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import {getMode, getSetting, navigate} from '@dvrd/dvr-controls'

export function onConnectBolOauth() {
    if (getMode() !== 'prod') return navigate('/oauth/bol');
    const clientId = getSetting('bolOauthClientId');
    if (!clientId) throw new Error('Bol OAuth client id is not set');
    const redirectUri = encodeURIComponent('https://app.bolmate.nl/oauth/bol');
    const uri = `https://login.bol.com/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&prompt=login`;
    window.location.assign(uri);
}